import { Directive, ElementRef, EventEmitter, Input, Output, Host, Self, Optional, AfterViewInit, OnDestroy } from '@angular/core';
import { MatAutocomplete } from '@angular/material';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil, } from 'rxjs/operators';


export interface IAutoCompleteScrollEvent {
  autoComplete: MatAutocomplete;
  scrollEvent: Event;
}

@Directive({
  selector: 'mat-autocomplete[optionsScroll]'
})
export class OptionsScrollDirective implements OnDestroy {

  @Input() thresholdPercent = .8;
  @Output('optionsScroll') scroll = new EventEmitter<IAutoCompleteScrollEvent>();
  destroyed$ = new Subject();

  constructor(public autoComplete: MatAutocomplete) {
    //TODO: Enable this when updating to Angular 6
    //this.autoComplete.opened.pipe(
    //  tap(() => {
    //    // Note: When autocomplete raises opened, panel is not yet created (by Overlay)
    //    // Note: The panel will be available on next tick
    //    // Note: The panel wil NOT open if there are no options to display
    //    setTimeout(() => {
    //      // Note: remove listner just for safety, in case the close event is skipped.
    //      this.removeScrollEventListener();
    //      this.autoComplete.panel.nativeElement
    //        .addEventListener('scroll', this.onScroll.bind(this))
    //    });
    //  }),
    //  takeUntil(this.destroyed$)).subscribe();

    //this.autoComplete.closed.pipe(
    //  tap(() => this.removeScrollEventListener()),
    //  takeUntil(this.destroyed$)).subscribe();
  }

  private removeScrollEventListener() {
    //this.autoComplete.panel.nativeElement
    //  .removeEventListener('scroll', this.onScroll);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();

    this.removeScrollEventListener();
  }

  onScroll(event: Event) {

    if (this.thresholdPercent === undefined) {
      this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
    } else {
      var target = event.target as any;
      const threshold = this.thresholdPercent * 100 * target.scrollHeight / 100;
      const current = target.scrollTop + target.clientHeight;

      //console.log(`scroll ${current}, threshold: ${threshold}`)
      if (current > threshold) {
        //console.log('load next page');
        this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/directives/options-scroll.directive.ts